import { Stack, useFocusEffect, useLocalSearchParams } from 'expo-router';
import { useSetAtom } from 'jotai';
import { useCallback, useEffect } from 'react';

import { selectedMembershipIdAtom } from '../../../entities/entityAtoms';
import { MembershipDetailsPage } from '../../../entities/membership/components/MembershipDetailsPage';

export default function MembershipIdPage() {
    const { id: membershipId } = useLocalSearchParams<{ id: string }>();
    const setSelectedMembershipId = useSetAtom(selectedMembershipIdAtom);

    // This effect will only run once per membership because each membership details page
    // is rendered separately in a navigation stack (thus, going back to previously viewed
    // memberships is fast)
    useEffect(() => {
        setSelectedMembershipId(membershipId);
    }, [membershipId, setSelectedMembershipId]);

    // This effect will run every time a membership is re-visited
    // so if the data fetch for this membership wasn't completed on the first visit,
    // this will trigger a new request for the data
    useFocusEffect(
        useCallback(() => {
            setSelectedMembershipId(membershipId);
        }, [membershipId, setSelectedMembershipId]),
    );

    return (
        <>
            <Stack.Screen
                options={{
                    title: 'Membership Details',
                }}
            />
            <MembershipDetailsPage membershipId={membershipId} />
        </>
    );
}
